module.exports = __webpack_public_path__ + "img/平台端图标.dc0d09b7.png";